/* ciúb collection cards: option pickers, Add to bag, dynamic checkout, reward tick, arrival tag */
(function () {
  'use strict';
  if (window.__ciubCardBuy) return;
  window.__ciubCardBuy = true;
  var ME = document.currentScript && document.currentScript.src;

  // shared delivery-date rules (assets/ciub-eta.js), loaded once from the same folder as this file
  function loadEta(src, done) {
    if (window.ciubEta) return done();
    document.addEventListener('ciub:eta-ready', done);
    if (window.__ciubEtaLoading || !src) return;
    window.__ciubEtaLoading = true;
    var s = document.createElement('script'); s.src = src.replace(/[^\/]+\.js(\?.*)?$/, 'ciub-eta.js'); s.async = true;
    document.head.appendChild(s);
  }
  var ETA_TOP = true;

  function cfg() {
    var el = document.getElementById('cb-config');
    try { return el ? JSON.parse(el.textContent) : {}; } catch (e) { return {}; }
  }

  /* ---------- money (formatted from samples Shopify renders in the visitor's currency) ---------- */
  function money(cents) {
    var c = cfg(), W = c.sampleWhole || '', D = c.sampleDec || '';
    if (cents % 100 === 0 && /1\D?000/.test(W)) {
      var sep = (W.match(/1(\D?)000/) || [])[1] || '';
      return W.replace(/1\D?000/, String(cents / 100).replace(/\B(?=(\d{3})+(?!\d))/g, sep));
    }
    var dm = D.match(/1(\D)50/), ds = dm ? dm[1] : '.';
    return /1\D50/.test(D) ? D.replace(/1\D50/, (cents / 100).toFixed(2).replace('.', ds)) : (cents / 100).toFixed(2);
  }

  /* ---------- arrival date (same rules as the product page and cart) ---------- */
  var ETA = {
    GB: { mode: 'by', days: 3 }, IM: { mode: 'by', days: 3 }, IE: { mode: 'by', days: 3 },
    US: { mode: 'between', min: 3, max: 5 }, NL: { mode: 'between', min: 3, max: 5 },
    DE: { mode: 'between', min: 3, max: 7 }, DEFAULT: { mode: 'between', min: 3, max: 7 }
  };
  function londonToday() {
    var p = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: 'numeric', day: 'numeric' })
      .formatToParts(new Date()).reduce(function (o, x) { o[x.type] = x.value; return o; }, {});
    return new Date(p.year, p.month - 1, p.day);
  }
  function addDays(d, n) { var x = new Date(d); x.setDate(x.getDate() + n); return x; }
  function wknd(d) { return d.getDay() === 0 || d.getDay() === 6; }
  function deliver(from, n) { var d = addDays(from, n); if (d.getDay() === 0) d = addDays(d, 1); return d; }
  function fmt(d, m) { return d.toLocaleDateString('en-GB', m ? { weekday: 'short', day: 'numeric', month: 'short' } : { weekday: 'short', day: 'numeric' }).replace(',', ''); }
  var etaText = null;
  function eta() {
    if (window.ciubEta) return window.ciubEta.get(cfg().country).label;
    if (etaText !== null) return etaText;
    var rule = ETA[cfg().country] || ETA.DEFAULT, today = londonToday(), dispatch = today;
    while (wknd(dispatch)) dispatch = addDays(dispatch, 1);
    if (rule.mode === 'by') etaText = 'Arrives by ' + fmt(deliver(dispatch, rule.days), true);
    else { var a = deliver(dispatch, rule.min), b = deliver(dispatch, rule.max); etaText = 'Arrives ' + fmt(a, a.getMonth() !== b.getMonth()) + ' – ' + fmt(b, true); }
    return etaText;
  }
  function reward(cents) {
    var c = cfg();
    if (!c.g1) return '';
    if (cents >= c.g2) return c.tG2;
    if (cents >= c.g1) return c.tG1;
    if (c.ship && cents >= c.ship) return c.tShip;
    return '';
  }

  /* ---------- swatch colours ---------- */
  var SW = { navy: '#24324A', beige: '#D9C8A9', green: '#4E6B55', pink: '#E8AEB9', khaki: '#8E8A5C', blue: '#3F8C9A',
    black: '#1D1D1D', red: '#B23A32', lemon: '#F1DB6E', 'sky-blue': '#9CC8E6', sage: '#B5C4A6', apricot: '#F2B488',
    lavender: '#C3B4E0', 'sea-blue': '#3B7F98', 'slate-blue': '#5A6F8A', grey: '#9A9A9A', white: '#F5F5F5', orange: '#E07B39' };
  function paintSwatches(box) {
    box.querySelectorAll('[data-cb-sw]').forEach(function (b) {
      var c = SW[b.getAttribute('data-cb-sw')];
      if (!c) { b.classList.add('is-text'); b.textContent = b.getAttribute('data-cb-pick'); return; }
      b.style.setProperty('--sw', c);
    });
  }

  /* ---------- card state ---------- */
  function variants(box) {
    if (!box._v) { try { box._v = JSON.parse(box.querySelector('[data-cb-variants]').textContent); } catch (e) { box._v = []; } }
    return box._v;
  }
  function current(box) {
    var list = variants(box), sels = box.querySelectorAll('[data-cb-opt]');
    if (!sels.length) return list[0];
    var want = {};  // option position -> picked value (selects and hidden inputs alike)
    [].forEach.call(sels, function (s) { want[+s.getAttribute('data-cb-opt')] = s.value; });
    for (var i = 0; i < list.length; i++) {
      var ok = true;
      var o = typeof list[i].o === 'string' ? [list[i].o] : list[i].o;
      for (var j in want) if (o[j] !== want[j]) { ok = false; break; }
      if (ok) return list[i];
    }
    return null;
  }
  // grey out choices that don't exist or are sold out with the other options as picked
  function markOptions(box) {
    var list = variants(box), sels = [].slice.call(box.querySelectorAll('[data-cb-opt]'));
    function inStock(idx, val) {
      return list.some(function (v) {
        var o = typeof v.o === 'string' ? [v.o] : v.o;
        if (o[idx] !== val || !v.a) return false;
        return sels.every(function (t) { var j = +t.getAttribute('data-cb-opt'); return j === idx || o[j] === t.value; });
      });
    }
    sels.forEach(function (s) {
      var idx = +s.getAttribute('data-cb-opt');
      if (s.tagName === 'SELECT') {
        [].forEach.call(s.options, function (o) { o.textContent = o.value + (inStock(idx, o.value) ? '' : ' — sold out'); });
        return;
      }
      var g = box.querySelector('[data-cb-group="' + s.getAttribute('data-cb-opt') + '"]');
      if (!g) return;
      g.querySelectorAll('[data-cb-pick]').forEach(function (b) {
        var val = b.getAttribute('data-cb-pick');
        b.classList.toggle('is-on', val === s.value);
        b.classList.toggle('is-out', !inStock(idx, val));
      });
      var nm = g.querySelector('[data-cb-name]'); if (nm) nm.textContent = s.value;
    });
  }
  function refresh(box, picked) {
    var v = current(box), add = box.querySelector('[data-cb-add]');
    var card = box.closest('.card-wrapper');
    if (picked && v && card) {
      // show the chosen colour / pack in the card photo (the hover photo too, so it can't cover the pick)
      if (v.img) card.querySelectorAll('.card__media img').forEach(function (img) {
        if (img.getAttribute('src') !== v.img) { img.removeAttribute('srcset'); img.src = v.img; }
      });
      // card links open the picked variant (on its own product page for sibling colours)
      card.querySelectorAll('a[href*="/products/"]').forEach(function (l) {
        var base = v.url || l.getAttribute('href').split('?')[0];
        l.setAttribute('href', base + '?variant=' + v.id);
      });
    }
    var ok = !!(v && v.a);
    add.disabled = !ok;
    box.querySelector('[data-cb-lbl]').textContent = v ? (ok ? (add.getAttribute('data-label') || 'Add to cart') : 'Sold out') : 'Unavailable';
    if (v) {
      box.querySelector('[data-cb-price]').textContent = money(v.p);
      // bundles: show the before price and the saving
      var was = box.querySelector('[data-cb-was]'), save = box.querySelector('[data-cb-save]');
      var showSave = !!(v.b && v.c > v.p);
      was.hidden = save.hidden = !showSave;
      if (showSave) { was.textContent = money(v.c); save.textContent = 'Save ' + money(v.c - v.p); }
    }
    var id = box.querySelector('[data-cb-id]'); if (id && v) id.value = v.id;
    var ex = box.querySelector('.cb__express'); if (ex) ex.hidden = !ok;
    var r = box.querySelector('[data-cb-reward]'), txt = v ? reward(v.p) : '';
    r.classList.toggle('is-empty', !txt); r.querySelector('span').textContent = txt || ' ';
    var e = box._eta || box.querySelector('[data-cb-eta]');
    if (cfg().showEta !== false) { e.textContent = eta(); e.hidden = false; }
    markOptions(box);
  }
  function initAll(root) {
    var found = 0;
    (root || document).querySelectorAll('[data-cb]').forEach(function (box) {
      if (box.dataset.cbReady) return;
      box.dataset.cbReady = '1';
      found++;
      paintSwatches(box);
      // "Arrives by" sits between the title and the stars (set ETA_TOP = false to put it back under the buttons)
      var eta = box.querySelector('[data-cb-eta]'), info = box.parentElement;
      if (ETA_TOP && eta && info && info.classList.contains('card-information')) {
        box._eta = eta; eta.classList.add('cb__eta--top'); info.insertBefore(eta, info.firstChild);
      }
      refresh(box);
    });
    return found;
  }

  document.addEventListener('change', function (e) {
    var s = e.target.closest && e.target.closest('[data-cb-opt]');
    if (s) { refresh(s.closest('[data-cb]'), true); level(); }
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-cb-pick]');
    if (!b) return;
    e.preventDefault();
    var g = b.closest('[data-cb-group]'), box = b.closest('[data-cb]');
    g.querySelector('[data-cb-opt]').value = b.getAttribute('data-cb-pick');
    refresh(box, true);
    level();
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-cb-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var box = btn.closest('[data-cb]'), v = current(box), err = box.querySelector('[data-cb-err]');
    if (!v) return;
    var lbl = box.querySelector('[data-cb-lbl]'), text = lbl.textContent;
    btn.disabled = true; lbl.textContent = 'Adding…'; err.hidden = true;
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status) { err.textContent = res.description || res.message || 'Couldn’t add that one, sorry.'; err.hidden = false; return; }
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function') { drawer.classList.remove('is-empty'); drawer.renderContents(res); }
      else window.location.href = '/cart';
    }).catch(function () {
      err.textContent = 'Couldn’t add that one, sorry. Please try again.'; err.hidden = false;
    }).then(function () { btn.disabled = false; lbl.textContent = text; });
  });

  /* ---------- line up the buy boxes: stars sit right under the title, and when a row mixes one- and
     two-line titles the spare space goes above the price, so price, options and buttons stay level ---------- */
  var levelT = null;
  function level() {
    clearTimeout(levelT);
    levelT = setTimeout(function () {
      document.querySelectorAll('.product-grid').forEach(function (grid) {
        var boxes = [].slice.call(grid.querySelectorAll('.card-wrapper [data-cb]'));
        boxes.forEach(function (b) {
          b.style.paddingTop = '';
          b.querySelectorAll('.cb__slot').forEach(function (s) { s.style.minHeight = ''; });
          var rw = b.querySelector('[data-cb-reward]'); if (rw) rw.classList.remove('is-gone');
        });
        var rows = {};
        boxes.forEach(function (b) {
          var item = b.closest('.grid__item, li') || b.closest('.card-wrapper');
          var t = Math.round(item.getBoundingClientRect().top);
          var off = b.getBoundingClientRect().top - item.getBoundingClientRect().top;
          (rows[t] = rows[t] || []).push([b, off]);
        });
        Object.keys(rows).forEach(function (t) {
          var row = rows[t].map(function (r) { return r[0]; });
          // reward line ("Free UK delivery"): only keep its space in rows where at least one card shows it
          var anyReward = row.some(function (b) { var rw = b.querySelector('[data-cb-reward]'); return rw && !rw.classList.contains('is-empty'); });
          if (!anyReward) row.forEach(function (b) { var rw = b.querySelector('[data-cb-reward]'); if (rw) rw.classList.add('is-gone'); });
          // pack and colour slots: each row takes its tallest, so buttons line up with no spare gap
          ['.cb__slot--pack', '.cb__slot--col'].forEach(function (sel) {
            var h = 0, slots = row.map(function (b) { return b.querySelector(sel); }).filter(Boolean);
            slots.forEach(function (s) { h = Math.max(h, s.getBoundingClientRect().height); });
            slots.forEach(function (s) { if (h > 0) s.style.minHeight = h + 'px'; });
          });
        });
        Object.keys(rows).forEach(function (t) {
          var max = 0; rows[t].forEach(function (r) { max = Math.max(max, r[1]); });
          rows[t].forEach(function (r) { var d = max - r[1]; if (d > 0.5) r[0].style.paddingTop = d + 'px'; });
        });
      });
    }, 50);
  }
  window.addEventListener('resize', level);
  window.addEventListener('load', function () { level(); setTimeout(level, 1500); setTimeout(level, 4000); });

  function start() {
    initAll();
    level();
    loadEta(ME, function () { document.querySelectorAll('[data-cb][data-cb-ready]').forEach(function (b) { refresh(b); }); });
    // filters, sorting and pagination swap the grid in place: set up the new cards and their checkout buttons
    var grid = document.getElementById('ProductGridContainer');
    if (grid && window.MutationObserver) {
      var t = null;
      new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(function () {
          // only when new cards arrived, so the checkout buttons' own rendering can't retrigger this
          if (initAll(grid)) {
            level();
            if (window.Shopify && Shopify.PaymentButton && typeof Shopify.PaymentButton.init === 'function') Shopify.PaymentButton.init();
          }
        }, 60);
      }).observe(grid, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
